<div class="row justify-content-center align-items-center start-chosse-type  onShow" style="min-height: 100vh;">
	<div class="document-container nextBtn  firstStep">
        <a routerLink="/business-documents"></a>
		<p>Business Documents</p>
		<img class="fingureClick " src="assets/imgs/clickFingure.gif">
		<img class="p-docimg " src="assets/imgs/busineessDoc.jpg">
	</div>
	<div class="document-container nextBtn  firstStep">
		<a [routerLink]="'/' + stateCode + '/personal-documents'"></a>
		<p>Personal Documents</p>
		<img class="fingureClick " src="assets/imgs/clickFingure.gif">
		<img class="p-docimg " src="assets/imgs/personalDocjpg.jpg">
	</div>
</div>